import React from 'react';
import { BaseFormField } from './BaseFormField';
import DatePickerComponent from '../date-picker';

interface DateInputProps {
    name: string;
    label: string;
    required?: boolean;
    disabled?: boolean;
    minDate?: Date;
    maxDate?: Date;
    onDateChange: (date: Date) => void;
    storedDate?: Date | null;
    placeholder?: string;
}

export const DateInput: React.FC<DateInputProps> = ({
    name,
    label,
    required = false,
    disabled = false,
    minDate,
    maxDate,
    onDateChange,
    storedDate,
    placeholder = '',
}) => (
    <div className="mb-4">
        <label className="fs-14 fw-400 mb-2" htmlFor={name}>
            {label} {required && <span className="lt-text-error">*</span>}
        </label>
        <BaseFormField name={name}>
            {({ field, error, setFieldValue, setFieldTouched }) => (
                <>
                    <div className={error ? 'react-datepicker-error' : ''}>
                        <DatePickerComponent
                            key={(field?.value as any) || storedDate}
                            onChange={(date: Date | [Date, Date | null] | null) => {
                                let selectedDate: Date | null = null;

                                if (date instanceof Date) {
                                    selectedDate = date;
                                } else if (Array.isArray(date) && date[0] instanceof Date) {
                                    selectedDate = date[0];
                                } else {
                                    selectedDate = null;
                                }

                                if (selectedDate) {
                                    onDateChange(selectedDate);
                                    setFieldTouched(field.name);
                                    setFieldValue(field.name, selectedDate);
                                }
                            }}
                            disabled={disabled}
                            headerSelects
                            startDate={(field?.value as Date) || storedDate}
                            minDate={minDate}
                            maxDate={maxDate}
                            placeholder={placeholder}
                        />
                    </div>
                    {typeof error === 'string' && <small className="text-danger fs-12">{error}</small>}
                </>
            )}
        </BaseFormField>
    </div>
);
